import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/edit.svg` */
export const EditIcon = createTripletGlyphIcon('EditIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0348 13.2148C14.3384 13.2149 14.5845 13.461 14.5846 13.7646C14.5846 14.0683 14.3385 14.3143 14.0348 14.3144H7.85122C7.54746 14.3144 7.30141 14.0683 7.30141 13.7646C7.30154 13.4609 7.54754 13.2148 7.85122 13.2148H14.0348Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0387 2.22259C10.8059 1.47532 12.0397 1.51347 12.7594 2.30657C13.43 3.04565 13.4113 4.17815 12.7165 4.89446L5.43911 12.3945C5.26422 12.5746 5.04542 12.7062 4.80434 12.7763L2.23598 13.5234C1.76498 13.6603 1.32167 13.2379 1.4352 12.7607L2.00551 10.3622C2.06905 10.0952 2.20737 9.85163 2.40395 9.66009L10.0387 2.22259ZM3.17153 10.4482C3.12447 10.4941 3.09115 10.5522 3.07583 10.6161L2.68716 12.246L4.4977 11.7197C4.55553 11.7028 4.60809 11.6711 4.65005 11.6279L10.6276 5.46673L9.41665 4.36321L3.17153 10.4482ZM11.945 3.04583C11.6438 2.71393 11.1274 2.69797 10.8063 3.01067L10.2057 3.59466L11.3942 4.67669L11.9274 4.12884C12.218 3.82909 12.2255 3.35511 11.945 3.04583Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.788 14.9355C16.0918 14.9355 16.3388 15.1815 16.3388 15.4853C16.3388 15.789 16.0918 16.0351 15.788 16.0351H8.83199C8.52845 16.0348 8.28221 15.7889 8.28219 15.4853C8.28219 15.1817 8.52844 14.9357 8.83199 14.9355H15.788Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3418 2.54973C12.1769 1.73637 13.5202 1.77734 14.3037 2.64055C15.0337 3.44516 15.0132 4.6791 14.2568 5.45891L6.07027 13.8954C5.88183 14.0895 5.64547 14.232 5.3857 14.3075L2.49606 15.1474C2.01704 15.2864 1.56551 14.8573 1.68063 14.372L2.3232 11.6738C2.39163 11.3862 2.54025 11.1233 2.75191 10.9169L11.3418 2.54973ZM3.51949 11.705C3.45729 11.7658 3.41272 11.843 3.39254 11.9277L2.92867 13.8759L5.07809 13.2509C5.15465 13.2286 5.22465 13.187 5.28024 13.1298L12.0546 6.14739L10.5918 4.81438L3.51949 11.705ZM13.4892 3.37981C13.1242 2.97766 12.4984 2.95892 12.1093 3.33782L11.3808 4.04583L12.8213 5.35735L13.4668 4.69329C13.8193 4.33 13.8294 3.75469 13.4892 3.37981Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.0518 19.8971C21.466 19.8971 21.8018 20.2329 21.8018 20.6471C21.8018 21.0613 21.466 21.3971 21.0518 21.3971H11.7764C11.3623 21.397 11.0264 21.0613 11.0264 20.6471C11.0264 20.2329 11.3623 19.8972 11.7764 19.8971H21.0518Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1104 3.38733C16.2307 2.29628 18.0331 2.3515 19.084 3.5094C20.0634 4.58876 20.0354 6.24361 19.0206 7.28967L13.563 12.9142L8.10553 18.5387C7.85219 18.7998 7.53492 18.9908 7.18561 19.0924L3.33307 20.2125C2.68176 20.4018 2.06866 19.8177 2.22564 19.1578L3.08111 15.5602C3.17315 15.1736 3.37366 14.8209 3.65826 14.5436L15.1104 3.38733ZM4.70514 15.6178C4.62423 15.6966 4.56738 15.797 4.54107 15.9069L3.92877 18.4762L6.76666 17.652C6.86612 17.623 6.95722 17.5681 7.02936 17.4938L16.0489 8.1969L14.1231 6.44202L4.70514 15.6178ZM17.9737 4.51721C17.4934 3.98808 16.6693 3.96303 16.1573 4.46155L15.1993 5.39319L17.0948 7.11877L17.9444 6.24475C18.4079 5.76666 18.4212 5.0104 17.9737 4.51721Z"
        fill="currentColor"
      />
    </svg>
  ),
});
